import React from 'react'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { Home, ArrowLeft } from 'lucide-react'

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-24">
      <div className="max-w-lg w-full text-center">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="inline-flex items-center justify-center p-4 bg-primary-100 rounded-full text-primary-600 mb-6">
            <span className="text-6xl font-bold">404</span>
          </div>
          
          <h1 className="text-3xl md:text-4xl font-bold mb-4">Page non trouvée</h1>
          <p className="text-lg text-gray-600 mb-8">
            La page que vous recherchez n'existe pas ou a été déplacée.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/" className="btn-primary w-full sm:w-auto">
              <Home size={18} className="mr-2" /> Retour à l'accueil
            </Link>
            <button 
              onClick={() => window.history.back()} 
              className="btn-outline w-full sm:w-auto"
            >
              <ArrowLeft size={18} className="mr-2" /> Page précédente
            </button>
          </div>
        </motion.div>
      </div>
    </div>
  )
}

export default NotFound
